import { useHttp } from "../index";
import { QuestionsProps } from "./types";

export const useGetQuestions = (quizId: string) =>
  useHttp<QuestionsProps>(`/quiz/${quizId}/questions/`, {
    method: "get",
  });
